import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1),
  width: '100%',
};

export const cardContent: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(0.5),
};

export const dataNotFoundWrapper: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: (p) => p.spacing(8),
  height: '100%',
};

export const scrollbarSX: SxStyle = {
  height: (p) => p.spacing(18.25),
};
